import { render, staticRenderFns } from "./ProductUnitsDeleteModal.vue?vue&type=template&id=2fdcfcff&scoped=true&"
import script from "./ProductUnitsDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProductUnitsDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdcfcff",
  null
  
)

export default component.exports